import type { ReactNode } from "react";
import { statusLabels, type RequestStatus } from "../lib/constants";

export function adminErrorMessage(error: string, status: number | null) {
  if (status === 401) {
    return "هذه الواجهة تتطلب دخولاً عبر Cloudflare Access قبل عرض بيانات الإدارة.";
  }
  return error;
}

export function AdminErrorMessage({
  error,
  status,
}: {
  error: string;
  status: number | null;
}) {
  return <p className="text-red-700">{adminErrorMessage(error, status)}</p>;
}

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <p className="rounded-md border border-line bg-sand p-4 text-ash">
      {children}
    </p>
  );
}

export function StatusBadge({ status }: { status: RequestStatus }) {
  const tone = statusTone(status);
  return (
    <span className={`status-badge status-badge-${tone}`}>
      {statusLabels[status]}
    </span>
  );
}

function statusTone(status: RequestStatus) {
  if (status === "closed") return "success";
  if (status === "cancelled" || status === "waiting_for_more_information") return "danger";
  if (
    status === "quotation_in_progress" ||
    status === "quotation_issued" ||
    status === "quotation_accepted" ||
    status === "work_order_issued" ||
    status === "inspection_scheduled" ||
    status === "report_in_progress" ||
    status === "internal_review"
  ) {
    return "warning";
  }
  return "info";
}
